import { render } from "./wcPage.vue?vue&type=template&id=13dd1bcd&scoped=true"
import script from "./wcPage.vue?vue&type=script&lang=js"
export * from "./wcPage.vue?vue&type=script&lang=js"

import "./wcPage.vue?vue&type=style&index=0&id=13dd1bcd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dd1bcd"]])

export default __exports__